import * as React from 'react';
import {RouteComponentProps} from "react-router";
import {
    AchievementQueryResult,
    useAchievementQuery,
    useCreateAchievementMutation,
    useUpdateAchievementMutation
} from "../../../../types.d";
import {Form} from "@intelingu/core/components/form/Form";
import {FormGroup} from "../../../partials/form/elements/FormGroup";
import {Field} from "@intelingu/core/components/form/Field";
import {TextInput} from "../../../partials/form/elements/TextInput";
import {TextArea} from "../../../partials/form/elements/TextArea";
import {SubmitButton} from "../../../partials/form/elements/SubmitButton";
import {ImageField} from "../../../partials/form/elements/ImageField";

class Validator {}

export const ProgressAchievementEdit = (props: RouteComponentProps<{ id: string, language: string }>) => {
    const id = props.match.params.id !== 'create' ? Number(props.match.params.id) : null;
    let item: AchievementQueryResult;

    const [ createAchievement, { data: createdAchievement } ] = useCreateAchievementMutation();
    const [ updateAchievement, { data: updatedAchievement } ] = useUpdateAchievementMutation();

    if (id) {
        item = useAchievementQuery({
            variables: { id }
        });
    }

    if (item && !item.data) {
        return null;
    }

    return <div>
        <Form
            validator={Validator}
            defaultData={item ? {
                position: item.data.achievement.position,
                description: item.data.achievement.description,
                image: item.data.achievement.imageId,
                sourceLanguage: item.data.achievement.sourceLanguage.id
            } : {
                type: 'progressbar_achievement',
                sourceLanguage: Number(props.match.params.language)
            }}
            onSubmit={async (data, done) => {
                if (id) {
                    await updateAchievement({
                        variables: { id, data }
                    });
                } else {
                    await createAchievement({
                        variables: { data }
                    });
                }

                done();
            }}>

            <FormGroup label={'Position'}>
                <Field
                    name={'position'}
                    render={props => <TextInput {...props} />} />
            </FormGroup>

            <FormGroup label={'Text'}>
                <Field
                    name={'description'}
                    render={props => <TextArea {...props} />} />
            </FormGroup>

            <FormGroup label={'Image'}>
                <Field
                    name={'image'}
                    render={props => <ImageField
                        defaultPreview={item ? item.data.achievement.image : null}
                        {...props} />} />
            </FormGroup>

            <div className={'col-12'}>
                <Field submit render={props => <SubmitButton {...props}>Done</SubmitButton>} />
            </div>
        </Form>
    </div>
};
